import ContentListingItem from "./ContentListingItem.jsx";
import { array } from "prop-types";
import { chunkAlternate } from "../../common/helpers.js";
import cx from "classnames";
import { useMemo } from "react";

const propTypes = { results: array };

const VariantTwo = (props) => {
  const { results } = props;

  const chunkedResults = useMemo(
    () => chunkAlternate(3, 2, results ? results : []),
    [results],
  );

  return (
    <div className="dynamic-content-listing__variant-two">
      {chunkedResults.map((group, i, arr) => (
        <div
          key={i}
          className={cx("dynamic-content-listing__results-row", {
            "dynamic-content-listing__results-row--three-up":
              group.length === 3,
            "dynamic-content-listing__results-row--two-up": group.length === 2,
          })}
        >
          {group.map((item, j) =>
            i === 0 ? (
              <ContentListingItem
                key={j}
                {...item}
                displayImage={true}
                variantType={2}
                columnCount={group.length}
              />
            ) : (
              <ContentListingItem
                displayImage={false}
                key={j}
                {...item}
                variantType={2}
                columnCount={group.length}
              />
            ),
          )}
        </div>
      ))}
    </div>
  );
};

VariantTwo.propTypes = propTypes;
export default VariantTwo;
